import React from "react";

function FolderIcon({ className }: { className: string }) {
  return (
    <svg viewBox="-1 -1 23.5 20" className={className}>
      <g transform="translate(-2.252 -4.5)">
        <path
          d="M23.154,7.172a1.072,1.072,0,0,0-1.108-1.117H12.608a.359.359,0,0,1-.3-.117L11.218,4.845l-.01-.01a1.056,1.056,0,0,0-.84-.335H5.7A1.156,1.156,0,0,0,4.5,5.617V9.163H23.154Z"
          transform="translate(-0.695)"
        />
        <path
          d="M3.805,13.219H3.4c-.622,0-1.229.248-1.142,1.18S3.4,24.634,3.4,24.634c.131.865.568,1.214,1.214,1.214H21.74c.617,0,1.02-.379,1.117-1.214,0,0,1.078-8.982,1.146-9.983s-.432-1.433-1.146-1.433H3.805Z"
          transform="translate(0 -2.695)"
        />
      </g>
    </svg>
  );
}

export { FolderIcon };
